// class Input {
//   static MoveLeft = 0;
//   static MoveRight = 1;
//   static MoveUp = 2;
//   static MoveDown = 3;
//   static FocusLeft = 4;
//   static FocusRight = 5;

//   // static ButtonX = 4;
//   // static ButtonY = 5;
//   // static ButtonB = 6;
//   // static ButtonA = 7;
//   // static TriggerLeft = 8;
//   // static TriggerRight = 9;

//   static keybindings = {
//     KeyW: this.MoveUp,
//     KeyA: this.MoveLeft,
//     KeyS: this.MoveDown,
//     KeyD: this.MoveRight,
//     ArrowUp: this.MoveUp,
//     ArrowLeft: this.MoveLeft,
//     ArrowDown: this.MoveDown,
//     ArrowRight: this.MoveRight
//   }

//   static fromKeyCode(code) {
//     return this.keybindings[code];
//   }
// }

const Input = {
  Ok: 0,
  Cancel: 1,
  MoveLeft: 2,
  MoveRight: 3,
  MoveUp: 4,
  MoveDown: 5,
  Look: 6,
  FocusNext: 7,
  FocusLeft: 8,
  FocusRight: 9,
  Open: 10,
  Close: 11,
  Rest: 12,
  Utility: 13
}

export default Input;